import React from 'react';
import { useNavigate } from 'react-router-dom';
import TermsOfService from '../components/TermsOfService';
import PieLegal from '../components/PieLegal';
import './legal.css';

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div className="pagina-legal">
      <header className="legal-encabezado">
        <div className="legal-encabezado-interior">
          {/* Ver la nota de PrivacyPolicyPage: se vuelve a donde se estaba. */}
          <button className="legal-volver" onClick={() => navigate(-1)}>
            ← Volver
          </button>
          <div>
            <h1>Términos y Condiciones</h1>
            <p>Las reglas del servicio</p>
          </div>
        </div>
      </header>

      <TermsOfService />
      <PieLegal />
    </div>
  );
};

export default TermsOfServicePage;
